import { useState } from "react";
import { Link } from "react-router-dom";
import { MENU, IMAGES } from "@/data/menu";

const TABS = [
  { key: "veg", label: "Veg Sliders", image: IMAGES.veg },
  { key: "nonVeg", label: "Non-Veg Sliders", image: IMAGES.chicken },
  { key: "sides", label: "Sides", image: IMAGES.fries },
  { key: "dessert", label: "Dessert", image: IMAGES.dessert },
  { key: "drinks", label: "Drinks", image: IMAGES.drinks },
];

export default function Menu() {
  const [tab, setTab] = useState("veg");
  const activeTab = TABS.find((t) => t.key === tab);
  const section = MENU[tab];

  return (
    <div data-testid="menu-page">
      {/* Page hero band */}
      <section className="py-14 md:py-20" style={{ background: "var(--goat-green)" }}>
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <span className="badge-sticker inline-block px-5 py-2 text-sm font-semibold uppercase tracking-widest mb-5" style={{ background: "var(--goat-orange)", color: "var(--goat-white)", borderColor: "var(--goat-cream)", boxShadow: "3px 3px 0px var(--goat-cream)" }} data-testid="menu-badge">
            Fresh • Made-to-order • Quick
          </span>
          <h1 className="text-5xl md:text-6xl uppercase tracking-tighter" style={{ color: "var(--goat-cream)" }} data-testid="menu-heading">
            Sliders &amp; More
          </h1>
          <p className="mt-4 text-lg md:text-xl max-w-xl" style={{ color: "var(--goat-cream)" }} data-testid="menu-subtext">
            Every slider is made fresh when you order. Pick your favourites and place your order.
          </p>
        </div>
      </section>

      {/* Tabbed menu */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 py-14">
        <div className="flex flex-wrap gap-2 md:gap-3 mb-10" data-testid="menu-tabs">
          {TABS.map((t) => (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              className="px-5 py-2.5 rounded-full font-semibold uppercase text-sm tracking-wide transition-colors"
              style={{
                background: tab === t.key ? "var(--goat-orange)" : "transparent",
                color: tab === t.key ? "var(--goat-white)" : "var(--goat-green)",
                border: "2.5px solid var(--goat-orange)",
              }}
              data-testid={`menu-tab-${t.key}`}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-6 mb-8 flex-wrap" data-testid={`menu-section-${tab}`}>
          <div className="sticker-card p-0 overflow-hidden w-28 h-28 shrink-0">
            <img src={activeTab.image} alt={section.title} className="w-full h-full object-cover" data-testid={`menu-image-${tab}`} />
          </div>
          <h2 className="text-4xl md:text-5xl uppercase" style={{ color: "var(--goat-orange)" }} data-testid={`menu-section-heading-${tab}`}>
            {section.title}
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {section.items.map((item) => (
            <div key={item.name} className="sticker-card p-6 flex items-baseline justify-between gap-3" data-testid={`menu-item-${item.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <span className="text-base md:text-lg font-medium" style={{ color: "var(--goat-green)" }}>{item.name}</span>
              <span className="font-display text-xl shrink-0" style={{ color: "var(--goat-orange)" }}>₹{item.price}</span>
            </div>
          ))}
        </div>
        {section.note && (
          <p className="mt-4 text-base italic" style={{ color: "var(--goat-green)" }} data-testid={`menu-note-${tab}`}>
            {section.note}
          </p>
        )}

        <div className="mt-16 text-center">
          <Link
            to="/order"
            className="sticker-btn inline-block px-8 py-4 font-display uppercase text-base"
            style={{ background: "var(--goat-orange)", color: "var(--goat-white)" }}
            data-testid="menu-order-btn"
          >
            Order Online
          </Link>
        </div>
      </section>
    </div>
  );
}
